export const EndScreen = () => {
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler("webViewClosed");
  } else if (process.env.REACT_APP_WHITELISTED_DOMAIN) {
    window.top.postMessage("close", process.env.REACT_APP_WHITELISTED_DOMAIN);
  }
  return <></>;
};
export default EndScreen;
